import { client } from '../../../../../../common-utils/libraries/axios/axios';
import USERS from '../apiUrls';

const mutationDeactivateUser = (onSuccess, onError) => {
    return {
        mutationFn: (userUuid) => {
            return client.put(USERS.DEACTIVATE_USER.url, { uuid: userUuid });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationDeactivateUser;